import { render, staticRenderFns } from "./GenericIntegratedDropzone.vue?vue&type=template&id=6d8bfd4a&"
import script from "./GenericIntegratedDropzone.vue?vue&type=script&lang=js&"
export * from "./GenericIntegratedDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports